<template>
  <div class="container_box">
    <!-- <img :src="$t('imgPath.homeBanner')" /> -->
    <!-- 首页头部 -->
    <!-- :style="{'border-bottom':top>500?'1px solid #eee':'none', opacityStyle}" -->
    <div class="hand_box" :style="opacityStyle">
      <div class="navbox">
        <div class="nav-left">
          <!-- <img :src="top < 500 ? require('@/assets/logo.png') :require('@/assets/logo2.png')" alt="沃时派客"> -->
          <!-- <svg-icon iconClass="baozi" style="width:100px;height:100px;" ></svg-icon> -->
          <!-- <svg-icon data_iconName="baozi" className="baozi_icon" /> -->
          <svg-icon v-if="top < 500" class="logo" icon-class="logo" />
          <svg-icon v-else class="logo" icon-class="logo2" />
        </div>
        <div class="menu-list">
          <div class="nav">
            <el-menu :default-active="this.$route.path" router class="el-menu-demo" mode="horizontal">
              <el-menu-item index="/home"> <span class="text" :style="{color: top > 500 ? '#000':'#fff'}"> {{ $t('nav.home') }}</span></el-menu-item>
              <el-menu-item index="/services"><span class="text" :style="{color: top > 500 ? '#000':'#fff'}"> {{ $t('nav.services') }}</span></el-menu-item>
              <!-- <el-submenu>
                <template slot="title">平台服务</template>
                <el-menu-item index="/services">成本优化</el-menu-item>
                <el-menu-item index="/services">管理提交</el-menu-item>
                <el-menu-item index="/services">质量保证</el-menu-item>
              </el-submenu> -->
              <el-menu-item index="/company"><span class="text" :style="{color: top > 500 ? '#000':'#fff'}">{{ $t('nav.company') }}</span></el-menu-item>
              <el-menu-item index="/platform"><span class="text" :style="{color: top > 500 ? '#000':'#fff'}">{{ $t('nav.platform') }}</span></el-menu-item>
              <!-- <el-submenu index="4">
                <template slot="title">{{ $t('nav.platform') }}</template>
                <el-menu-item><a style="background: #FFF;color: #000;" href="https://u.worthpack.com" target="_blank">{{ $t('nav.platformCustomer') }}</a></el-menu-item>
                <el-menu-item><a style="background: #FFF;color: #000;" href="https://s.worthpack.com" target="_blank">供应商系统</a></el-menu-item>
                <el-menu-item><a style="background: #FFF;color: #000;" href="https://c.worthpack.com" target="_blank">{{ $t('nav.platformSelf') }}</a></el-menu-item>
              </el-submenu> -->
              <el-menu-item index="/contactus"><span class="text" :style="{color: top > 500 ? '#000':'#fff'}">{{ $t('nav.contactus') }}</span></el-menu-item>
              <el-menu-item index="/news"><span class="text" :style="{color: top > 500 ? '#000':'#fff'}">{{ $t('nav.news') }}</span></el-menu-item>
              <el-menu-item @click="changeLang">
                <!-- {{ $t('language.name') }} -->
                <span class="language text" :style="{color: top > 500 ? '#000':'#fff'}" v-if="$i18n.locale === 'zh'">简 / <span> EN</span></span>
                <span class="language text" :style="{color: top > 500 ? '#000':'#fff'}" v-if="$i18n.locale === 'en'">EN / <span> 简</span></span>
              </el-menu-item>
            </el-menu>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  props: {

  },
  data() {
    return {
      activeIndex: '1',
      // opacityStyle: { opacity: 0 }
      opacityStyle: { display: 'flex' },
      top: 0

    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  deactivated() {
    console.log('--deactivated--');
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {

    handleScroll() {
      const top = document.documentElement.scrollTop //获取scroll偏移值
      // console.log(top);
      this.top = top
      let color = 0;
      let opacity = 0.3
      let backgroundColor = `rgba(0,0,0,0.3)`
      let borderBottom = 'none'

      if (top > 0 && top < 800) { //700
        color = Math.ceil(top * 0.3643) //255/700 
        let tmp = top * 0.001428  // 1/700
        opacity = tmp < 0.3 ? 0.3 : tmp

        if (top < 15) {
          this.opacityStyle = {
            backgroundColor: 'rgba(0,0,0,0.3)',
            display: 'flex'
          }
        } else {
          backgroundColor = `rgba(${color}, ${color}, ${color}, ${opacity > 0.95 ? 1 : opacity})`
          console.log(backgroundColor, '-----', top);
          top > 500 ? borderBottom = '1px solid #eee' : ''
          this.opacityStyle = {
            backgroundColor,
            borderBottom,
            display: 'flex'
          }
        }
      } else if (top > 800) {
        this.opacityStyle = {
          backgroundColor: 'rgba(255,255,255,1)',
          borderBottom: '1px solid #eee'
        }
        if (this.$route.path == '/services') {
          this.opacityStyle = {
            backgroundColor: 'rgba(255,255,255,1)',
            borderBottom: '1px solid #eee',
            display: top > 1060 ? 'none' : 'flex'
          }
        }
      }

    },
    changeLang() {
      console.log(this.$i18n.locale)
      if (this.$i18n.locale === "zh") {
        this.$i18n.locale = "en"
        localStorage.setItem('user_lang', 'en');
      } else {
        this.$i18n.locale = "zh"
        localStorage.setItem('user_lang', 'zh');
      }
    }
  }
};
</script>

<style lang="less" scoped>
.container_box {
  width: 100%;
  display: flex;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .hand_box {
    position: fixed;
    top: 0;
    width: 100%;
    height: 88px;
    background-color: rgba(0, 0, 0, 0.3);
    line-height: 88px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
    .navbox {
      height: 88px;
      width: 1200px;
      display: flex;
      justify-content: space-between;
      @media screen and (max-width: 970px) {
        width: 660px;
      }
      .nav-left {
        display: flex;
        justify-content: center;
        align-items: center;
        .logo {
          width: 180px;
          height: 40px;
        }
      }
      .nav {
        width: 800px;
        .text {
          font-size: 18px;
          color: #ffffff;
        }
        .text:hover {
          font-weight: bold;
        }
        /deep/.el-menu {
          border: none;
          background: none;
        }
        /deep/.el-menu--horizontal > .el-menu-item {
          height: 100px;
          line-height: 100px;
          border: none;
          // color: #ffffff;
          // font-size: 18px;
        }
        /deep/.el-menu--horizontal > .el-submenu .el-submenu__title {
          height: 88px;
          line-height: 88px;
          border-bottom: none;
          // color: #ffffff;
          // font-size: 20px;
        }
        /deep/.el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
          background: none;
          // color: #ffffff;
          // font-weight: 600;
        }
        /deep/.el-menu--horizontal > .el-submenu .el-submenu__title:hover {
          background: none;
        }
        .el-submenu__title:focus,
        .el-submenu__title:hover {
          outline: 0;
          background: none;
        }
        /deep/.el-menu--horizontal > .el-menu-item:not(.is-disabled):focus {
          background: none;
        }
        /deep/.el-submenu .el-submenu__title {
          // font-size: 18px !important;
        }
      }
    }
  }
}
.language {
  color: #ffffff;
  display: flex;
  align-items: center;
  span {
    color: #aba9a9;
  }
}
</style>
